import {
    forms,
} from '@/store/modules';

export {
    forms,
};
